function loading(name, start) {
  const { promises = (loading.promises = {}) } = loading

  if (!promises[name]) {
    promises[name] = start().finally(() => {
      delete promises[name]
    })
  }

  return promises[name]
}

export function generateInit(options) {
  if (typeof options === 'string') {
    options = { name: options };
  }

  const {
    name,
    action = 'load',
    extractData = state => state[name],
    checkInitialized = state => {
      const value = extractData(state);

      return Array.isArray(value)
        ? value.length
        : value !== undefined;
    },
  } = options;

  return ({state, dispatch}, options) => checkInitialized(state)
    ? Promise.resolve(extractData(state))
    : dispatch(action, options)
      .then(() => extractData(state))
}
